import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'

import { PaginatedResponse, PaginationRequest } from '@yoshu-lib/models/paginated-response.model'

import { ENVIRONMENT } from '@yoshu-lib/core/tokens/environment.token'

import { cleanHttpParams } from '@yoshu-lib/utils/clean-http-params'

import { ProtocolSession, ProtocolSessionCreatePayload } from './protocol-sessions.model'

@Injectable({ providedIn: 'root' })
export class ProtocolSessionsService {
  private readonly env = inject(ENVIRONMENT)
  private readonly http = inject(HttpClient)

  getSessions(pagination?: PaginationRequest) {
    const params = cleanHttpParams({
      page: pagination?.page,
      page_size: pagination?.size
    })

    return this.http.get<PaginatedResponse<ProtocolSession>>(
      `${this.env.apiUrl}/protocols/sessions/`,
      {
        params
      }
    )
  }

  createSession(payload: ProtocolSessionCreatePayload) {
    return this.http.post<ProtocolSession>(`${this.env.apiUrl}/protocols/sessions/`, payload)
  }

  getSessionById(id: string) {
    return this.http.get<ProtocolSession>(`${this.env.apiUrl}/protocols/sessions/${id}/`)
  }
}
